module.exports = __webpack_public_path__ + "static/img/home.2e8d64e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toutiao/home.png
// module id = uGue
// module chunks = 156